import React from 'react';
import { useLocation } from 'react-router-dom';
import SEO from './SEO.js';
import { getMetaForPath } from '../utils/seo.js';
import { useLanguage } from '../context/LanguageContext.js';

const RouteSEOManager = () => {
  const location = useLocation();
  const { currentLanguage } = useLanguage();
  const meta = getMetaForPath(location.pathname, currentLanguage);

  return <SEO {...meta} />;
};

export default RouteSEOManager;
